import React from 'react'
import cx from 'classnames'
import RA from 'ra-config'
import Icon from 'lib/components/icon'
import { coreSiteUrl } from 'lib/config/url'

const { globalNavigation, logoPath } = RA.app.page

class MobileHeader extends React.PureComponent {
  static defaultProps = {
    logoWidth: '141.8px',
    logoHeight: '31px',
    naxAuxContent: null
  }

  state = {
    isActive: false
  }

  open = () => {
    this.setState({ isActive: true })
  }

  close = () => {
    this.setState({ isActive: false })
  }

  toggle = () => {
    this.state.isActive ? this.close() : this.open()
  }

  renderMenuItem({ text, path }) {
    let href = coreSiteUrl(path)

    return (
      <a key={href} href={href}>
        {text}
      </a>
    )
  }

  renderAuxContent() {
    const { navAuxContent } = this.props

    return navAuxContent ? React.createElement(navAuxContent) : null
  }

  render() {
    const { logoHeight, logoWidth, logoUrl } = this.props
    const { isActive } = this.state

    const menuClassname = cx('mobile-header__menu', {
      '-active': this.state.isActive
    })

    const menuButtonType = isActive ? 'x' : 'hamburger'

    return (
      <div className="mobile-header">
        <button
          className="mobile-header__menu-button"
          aria-controls="mobile-header-menu"
          onClick={this.toggle}
        >
          <Icon
            type={menuButtonType}
            height="16px"
            width="16px"
            className="block-icon"
          />
          <span className="screenreader-only">Toggle Menu</span>
        </button>
        <a href={coreSiteUrl(logoPath)} className="mobile-header__logo">
          <img
            src={logoUrl}
            width={logoWidth}
            height={logoHeight}
            className="block-icon"
            alt="Menu"
          />
        </a>
        <div id="mobile-header-menu" className={menuClassname}>
          {globalNavigation.map(this.renderMenuItem, this)}
        </div>
        {this.renderAuxContent()}
      </div>
    )
  }
}

export default MobileHeader



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/header/mobile-header.js